"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrincipalShortNames = void 0;
const getPrincipalShortNames = (principals) => {
    if (!principals)
        return [];
    const ssamGroupNameSplitter = '-dl-';
    return principals.map((principal) => principal.split(ssamGroupNameSplitter)[1]);
};
exports.getPrincipalShortNames = getPrincipalShortNames;
